export default __webpack_public_path__ + "static/IBMPlexSans-LightItalic-Cyrillic-abeb6d68a7f128eaa1cd1ce8884fd8e8.woff";